/* IndexedDB wrapper for TrailBack — stores treks and app settings locally. */

const DB_NAME = 'trailback';
const DB_VERSION = 1;
const STORE_TREKS = 'treks';
const STORE_SETTINGS = 'settings';

let dbPromise = null;

function openDB() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_TREKS)) {
        const s = db.createObjectStore(STORE_TREKS, { keyPath: 'id' });
        s.createIndex('startedAt', 'startedAt');
        s.createIndex('isDemo', 'isDemo');
      }
      if (!db.objectStoreNames.contains(STORE_SETTINGS)) {
        db.createObjectStore(STORE_SETTINGS, { keyPath: 'key' });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

function tx(store, mode = 'readonly') {
  return openDB().then((db) => db.transaction(store, mode).objectStore(store));
}

export async function saveTrek(trek) {
  const store = await tx(STORE_TREKS, 'readwrite');
  return new Promise((resolve, reject) => {
    const req = store.put(trek);
    req.onsuccess = () => resolve(trek);
    req.onerror = () => reject(req.error);
  });
}

export async function getTrek(id) {
  const store = await tx(STORE_TREKS);
  return new Promise((resolve, reject) => {
    const req = store.get(id);
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = () => reject(req.error);
  });
}

export async function listTreks() {
  const store = await tx(STORE_TREKS);
  return new Promise((resolve, reject) => {
    const results = [];
    const req = store.openCursor(null, 'prev');
    req.onsuccess = (e) => {
      const cur = e.target.result;
      if (cur) { results.push(cur.value); cur.continue(); }
      else resolve(results.sort((a, b) => (b.startedAt || 0) - (a.startedAt || 0)));
    };
    req.onerror = () => reject(req.error);
  });
}

export async function deleteTrek(id) {
  const store = await tx(STORE_TREKS, 'readwrite');
  return new Promise((resolve, reject) => {
    const req = store.delete(id);
    req.onsuccess = () => resolve(true);
    req.onerror = () => reject(req.error);
  });
}

export async function getSetting(key, def = null) {
  const store = await tx(STORE_SETTINGS);
  return new Promise((resolve) => {
    const req = store.get(key);
    req.onsuccess = () => resolve(req.result ? req.result.value : def);
    req.onerror = () => resolve(def);
  });
}

export async function setSetting(key, value) {
  const store = await tx(STORE_SETTINGS, 'readwrite');
  return new Promise((resolve, reject) => {
    const req = store.put({ key, value });
    req.onsuccess = () => resolve(true);
    req.onerror = () => reject(req.error);
  });
}
